import React from 'react';
import { InsuranceType } from '../../api/useInsuranceQuery';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { InstitutionNameInput } from '../../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/components/InstitutionNameInput/InstitutionNameInput';
import { AccountOwnerSelect } from '../components/AccountOwnerSelect/AccountOwnerSelect';
import { AccountDescription } from '../components/AccountDescription/AccountDescription';
import { IsBrokerOfRecord } from '../components/IsBrokerOfRecord/IsBrokerOfRecord';
import { HealthInsuredMembersSelect } from '../components/HealthInsuredMembersSelect/HealthInsuredMembersSelect';
import { HealthInsurancePlanType } from '../components/HealthInsurancePlanType/HealthInsurancePlanType';
import { Premium } from '../components/Premium/Premium';
import { PremiumEndYear } from '../components/PremiumEndYear/PremiumEndYear';
import { HealthIndividualDeductible } from '../components/HealthIndividualDeductible/HealthIndividualDeductible';
import { HealthFamilyDeductible } from '../components/HealthFamilyDeductible/HealthFamilyDeductible';
import { HealthCoinsurance } from '../components/HealthCoinsurance/HealthCoinsurance';
import { HealthCopayment } from '../components/HealthCopayment/HealthCopayment';
import { HealthOutOfPocketLimit } from '../components/HealthOutOfPocketLimit/HealthOutOfPocketLimit';
import { TabsContent } from '../components/TabsContent/TabsContent';
import { InsuranceData } from '../../useInsurance';
import { FormProps } from '../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { ManagementStyles } from '../components/ManagementStyles/ManagementStyles';
import { AssetBucketing } from '../components/AssetBucketing/AssetBucketing';

interface TabProps {
  data: InsuranceData;
}

export const Summary = ({ data }: TabProps) => {
  return (
    <Box display="flex" flexDirection="column" mt="16" css="gap: 16px">
      <InstitutionNameInput isInsurance />

      <AccountOwnerSelect data={data} insuranceType={InsuranceType.HealthInsurance} />

      <AccountDescription />

      <HealthInsuredMembersSelect data={data} />

      <ManagementStyles data={data} />

      <AssetBucketing data={data} />

      <IsBrokerOfRecord />
    </Box>
  );
};

export const PolicyDetails = ({ data }: TabProps) => {
  return (
    <Box display="flex" flexDirection="column" mt="16" css="gap: 16px">
      <HealthInsurancePlanType data={data} />

      <Premium />

      <PremiumEndYear data={data} />

      <HealthIndividualDeductible />

      <HealthFamilyDeductible />

      <HealthCoinsurance />

      <HealthCopayment />

      <HealthOutOfPocketLimit />
    </Box>
  );
};

const tabs = [
  {
    name: 'Summary',
    Component: Summary,
  },
  {
    name: 'Policy Details',
    Component: PolicyDetails,
  },
];

export const HealthInsuranceForm = (props: FormProps) => {
  return <TabsContent tabs={tabs} {...props} />;
};
